import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { useSelector } from "react-redux";
import { exportTableToExcel } from "../utils/exportTableToExcel";
import "./globalList.scss";
import Url from "../global";
import * as FaIcons from "react-icons/fa";

const RiwayatPelatihanList = () => {
  const [riwayatPelatihans, setRiwayatPelatihan] = useState([]);
  const { pegawai } = useSelector((state) => state.auth);
  const [query, setQuery] = useState("");
  const [query2, setQuery2] = useState("");
  const [order, setOrder] = useState("ASC");

  const sorting = (col) => {
    if (order === "ASC") {
      const sorted = [...riwayatPelatihans].sort((a, b) =>
        a[col].toLowerCase() > b[col].toLowerCase() ? 1 : -1
      );
      setRiwayatPelatihan(sorted);
      setOrder("DSC");
    }
    if (order === "DSC") {
      const sorted = [...riwayatPelatihans].sort((a, b) =>
        a[col].toLowerCase() < b[col].toLowerCase() ? 1 : -1
      );
      setRiwayatPelatihan(sorted);
      setOrder("ASC");
    }
  };

  useEffect(() => {
    getRiwayatPelatihan();
  }, []);

  const getRiwayatPelatihan = async () => {
    const response = await axios.get(`${Url}/riwayat_pelatihans`);
    setRiwayatPelatihan(response.data);
  };

  const deleteRiwayatPelatihan = async (riwayatPelatihanId) => {
    await axios.delete(`${Url}/riwayat_pelatihans/${riwayatPelatihanId}`);
    getRiwayatPelatihan();
  };

  const download = (e) => {
    console.log(e.target.href);
    fetch(e.target.href, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const blob = new Blob([buffer]);
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Sertifikat Pelatihan.pdf"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <div>
      <h1 className="title">Riwayat Pelatihan</h1>
      {/* <h2 className="subtitle">List Of Riwayat Pelatihan</h2> */}

      {pegawai &&
        (pegawai.strRole === "user" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "staff TU" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "admin") && (
          <Link to="/riwayat-pelatihan/add" className="button is-primary mb-2">
            Add New Riwayat Pelatihan
          </Link>
        )}

      <button
        type="button"
        className="download-table-xls-button"
        onClick={() =>
          exportTableToExcel({
            tableId: "table-to-xls",
            filename: "Table Riwayat Pelatihan",
          })
        }
      >
        Download as XLS
      </button>
      <br />
      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && <label> Masukan Nama </label>}
      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && (
          <input
            className="search"
            placeholder="Cari Nama Individu"
            onChange={(e) => setQuery(e.target.value.toLowerCase())}
          />
        )}
      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && (
          <label className="label-unit">Masukan Unit </label>
        )}

      {pegawai &&
        (pegawai.strRole === "admin" ||
          pegawai.strRole === "kepsek" ||
          pegawai.strRole === "kabid kepegawaian" ||
          pegawai.strRole === "staff TU") && (
          <input
            className="search"
            placeholder="Cari Berdasarkan Unit"
            onChange={(e) => setQuery2(e.target.value.toLowerCase())}
          />
        )}

      <div className="table__wrapper_Scroll_Log">
        <table
          className="table is-bordered is-striped is-narrow is-hoverable is-fullwidth"
          id="table-to-xls"
        >
          <thead>
            <tr>
              <th className="has-text-centered">No</th>
              <th className="has-text-centered">Nama Pelatihan</th>
              <th className="has-text-centered">Penyelenggara</th>
              <th className="has-text-centered">Tanggal Mulai</th>
              <th className="has-text-centered">Tanggal Selesai</th>
              <th className="has-text-centered">Nomor Sertifikat</th>
              <th className="has-text-centered">Sertifikat Pelatihan</th>
              <th
                className="has-text-centered"
                onClick={() => sorting("strStatus")}
              >
                Status <FaIcons.FaSort />
              </th>
              <th className="has-text-centered">Komentar</th>
              <th className="has-text-centered">Created by</th>
              <th className="has-text-centered">Unit</th>
              <th className="has-text-centered">Action</th>
            </tr>
          </thead>
          {pegawai && pegawai.strRole === "user" && (
            <tbody>
              {riwayatPelatihans.map((riwayatPelatihan, index) =>
                riwayatPelatihan.strStatus ===
                  "Pengajuan Sertifikat Pelatihan" ||
                  riwayatPelatihan.strStatus === "Ditolak Kabid Kepegawaian" ? (
                  <tr key={riwayatPelatihan.uuid}>
                    {index === 0}
                    <td>{index + 1}</td>
                    <td>{riwayatPelatihan.strNamaPelatihan}</td>
                    <td>{riwayatPelatihan.strPenyelenggara}</td>

                    <td>
                      {moment(riwayatPelatihan.dateTglMulai).format(
                        "DD/MM/YYYY"
                      )}
                    </td>
                    <td>
                      {moment(riwayatPelatihan.dateTglSelesai).format(
                        "DD/MM/YYYY"
                      )}
                    </td>
                    <td>{riwayatPelatihan.strNoSertifikat}</td>
                    <td>
                      <a
                        href={riwayatPelatihan.url}
                        download
                        onClick={(e) => download(e)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa fa-download" />
                        Sertifikat Pelatihan
                      </a>
                    </td>
                    <td>{riwayatPelatihan.strStatus}</td>
                    <td>{riwayatPelatihan.strKomentar}</td>
                    <td>{riwayatPelatihan.pegawai.strNama}</td>
                    <td>{riwayatPelatihan.pegawai.strUnit}</td>
                    <td>
                      <Link
                        to={`/riwayat-pelatihan/edit/${riwayatPelatihan.uuid}`}
                        className="button is-small is-info"
                      >
                        Edit
                      </Link>
                      <button
                        onClick={() =>
                          deleteRiwayatPelatihan(riwayatPelatihan.uuid)
                        }
                        className="button is-small is-danger"
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ) : (
                  <tr key={riwayatPelatihan.uuid}>
                    {index === 0}
                    <td>{index + 1}</td>
                    <td>{riwayatPelatihan.strNamaPelatihan}</td>
                    <td>{riwayatPelatihan.strPenyelenggara}</td>

                    <td>
                      {moment(riwayatPelatihan.dateTglMulai).format(
                        "DD/MM/YYYY"
                      )}
                    </td>
                    <td>
                      {moment(riwayatPelatihan.dateTglSelesai).format(
                        "DD/MM/YYYY"
                      )}
                    </td>
                    <td>{riwayatPelatihan.strNoSertifikat}</td>
                    <td>
                      <a
                        href={riwayatPelatihan.url}
                        download
                        onClick={(e) => download(e)}
                        target="_blank"
                        rel="noreferrer"
                      >
                        <i className="fa fa-download" />
                        Sertifikat Pelatihan
                      </a>
                    </td>
                    <td>{riwayatPelatihan.strStatus}</td>
                    <td>{riwayatPelatihan.strKomentar}</td>
                    <td>{riwayatPelatihan.pegawai.strNama}</td>
                    <td>{riwayatPelatihan.pegawai.strUnit}</td>
                  </tr>
                )
              )}
            </tbody>
          )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "PAUD IT Al Hasanah 1" && (
              <tbody>
                {riwayatPelatihans
                  .filter(
                    (riwayatPelatihan) =>
                      riwayatPelatihan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatPelatihan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatPelatihan, index) =>
                    riwayatPelatihan.pegawai.strUnit ===
                      "PAUD IT Al Hasanah 1" ? (
                      <tr key={riwayatPelatihan.uuid}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatPelatihan.strNamaPelatihan}</td>
                        <td>{riwayatPelatihan.strPenyelenggara}</td>

                        <td>
                          {moment(riwayatPelatihan.dateTglMulai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>
                          {moment(riwayatPelatihan.dateTglSelesai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatPelatihan.strNoSertifikat}</td>
                        <td>
                          <a
                            href={riwayatPelatihan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Pelatihan
                          </a>
                        </td>
                        <td>{riwayatPelatihan.strStatus}</td>
                        <td>{riwayatPelatihan.strKomentar}</td>
                        <td>{riwayatPelatihan.pegawai.strNama}</td>
                        <td>{riwayatPelatihan.pegawai.strUnit}</td>
                        <td>
                          <Link
                            to={`/riwayat-pelatihan/edit/${riwayatPelatihan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatPelatihan(riwayatPelatihan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "PAUD IT Al Hasanah 2" && (
              <tbody>
                {riwayatPelatihans
                  .filter(
                    (riwayatPelatihan) =>
                      riwayatPelatihan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatPelatihan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatPelatihan, index) =>
                    riwayatPelatihan.pegawai.strUnit ===
                      "PAUD IT Al Hasanah 2" ? (
                      <tr key={riwayatPelatihan.uuid}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatPelatihan.strNamaPelatihan}</td>
                        <td>{riwayatPelatihan.strPenyelenggara}</td>

                        <td>
                          {moment(riwayatPelatihan.dateTglMulai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>
                          {moment(riwayatPelatihan.dateTglSelesai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatPelatihan.strNoSertifikat}</td>
                        <td>
                          <a
                            href={riwayatPelatihan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Pelatihan
                          </a>
                        </td>
                        <td>{riwayatPelatihan.strStatus}</td>
                        <td>{riwayatPelatihan.strKomentar}</td>
                        <td>{riwayatPelatihan.pegawai.strNama}</td>
                        <td>{riwayatPelatihan.pegawai.strUnit}</td>
                        <td>
                          <Link
                            to={`/riwayat-pelatihan/edit/${riwayatPelatihan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatPelatihan(riwayatPelatihan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SDIT Al Hasanah 1" && (
              <tbody>
                {riwayatPelatihans
                  .filter(
                    (riwayatPelatihan) =>
                      riwayatPelatihan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatPelatihan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatPelatihan, index) =>
                    riwayatPelatihan.pegawai.strUnit ===
                      "SDIT Al Hasanah 1" ? (
                      <tr key={riwayatPelatihan.uuid}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatPelatihan.strNamaPelatihan}</td>
                        <td>{riwayatPelatihan.strPenyelenggara}</td>

                        <td>
                          {moment(riwayatPelatihan.dateTglMulai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>
                          {moment(riwayatPelatihan.dateTglSelesai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatPelatihan.strNoSertifikat}</td>
                        <td>
                          <a
                            href={riwayatPelatihan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Pelatihan
                          </a>
                        </td>
                        <td>{riwayatPelatihan.strStatus}</td>
                        <td>{riwayatPelatihan.strKomentar}</td>
                        <td>{riwayatPelatihan.pegawai.strNama}</td>
                        <td>{riwayatPelatihan.pegawai.strUnit}</td>
                        <td>
                          <Link
                            to={`/riwayat-pelatihan/edit/${riwayatPelatihan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatPelatihan(riwayatPelatihan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SDIT Al Hasanah 2" && (
              <tbody>
                {riwayatPelatihans
                  .filter(
                    (riwayatPelatihan) =>
                      riwayatPelatihan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatPelatihan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatPelatihan, index) =>
                    riwayatPelatihan.pegawai.strUnit ===
                      "SDIT Al Hasanah 2" ? (
                      <tr key={riwayatPelatihan.uuid}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatPelatihan.strNamaPelatihan}</td>
                        <td>{riwayatPelatihan.strPenyelenggara}</td>

                        <td>
                          {moment(riwayatPelatihan.dateTglMulai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>
                          {moment(riwayatPelatihan.dateTglSelesai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatPelatihan.strNoSertifikat}</td>
                        <td>
                          <a
                            href={riwayatPelatihan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Pelatihan
                          </a>
                        </td>
                        <td>{riwayatPelatihan.strStatus}</td>
                        <td>{riwayatPelatihan.strKomentar}</td>
                        <td>{riwayatPelatihan.pegawai.strNama}</td>
                        <td>{riwayatPelatihan.pegawai.strUnit}</td>
                        <td>
                          <Link
                            to={`/riwayat-pelatihan/edit/${riwayatPelatihan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatPelatihan(riwayatPelatihan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SMPI Al Hasanah" && (
              <tbody>
                {riwayatPelatihans
                  .filter(
                    (riwayatPelatihan) =>
                      riwayatPelatihan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatPelatihan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatPelatihan, index) =>
                    riwayatPelatihan.pegawai.strUnit === "SMPI Al Hasanah" ? (
                      <tr key={riwayatPelatihan.uuid}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatPelatihan.strNamaPelatihan}</td>
                        <td>{riwayatPelatihan.strPenyelenggara}</td>

                        <td>
                          {moment(riwayatPelatihan.dateTglMulai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>
                          {moment(riwayatPelatihan.dateTglSelesai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatPelatihan.strNoSertifikat}</td>
                        <td>
                          <a
                            href={riwayatPelatihan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Pelatihan
                          </a>
                        </td>
                        <td>{riwayatPelatihan.strStatus}</td>
                        <td>{riwayatPelatihan.strKomentar}</td>
                        <td>{riwayatPelatihan.pegawai.strNama}</td>
                        <td>{riwayatPelatihan.pegawai.strUnit}</td>
                        <td>
                          <Link
                            to={`/riwayat-pelatihan/edit/${riwayatPelatihan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatPelatihan(riwayatPelatihan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "SMAIT Al Hasanah" && (
              <tbody>
                {riwayatPelatihans
                  .filter(
                    (riwayatPelatihan) =>
                      riwayatPelatihan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatPelatihan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatPelatihan, index) =>
                    riwayatPelatihan.pegawai.strUnit === "SMAIT Al Hasanah" ? (
                      <tr key={riwayatPelatihan.uuid}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatPelatihan.strNamaPelatihan}</td>
                        <td>{riwayatPelatihan.strPenyelenggara}</td>

                        <td>
                          {moment(riwayatPelatihan.dateTglMulai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>
                          {moment(riwayatPelatihan.dateTglSelesai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatPelatihan.strNoSertifikat}</td>
                        <td>
                          <a
                            href={riwayatPelatihan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Pelatihan
                          </a>
                        </td>
                        <td>{riwayatPelatihan.strStatus}</td>
                        <td>{riwayatPelatihan.strKomentar}</td>
                        <td>{riwayatPelatihan.pegawai.strNama}</td>
                        <td>{riwayatPelatihan.pegawai.strUnit}</td>
                        <td>
                          <Link
                            to={`/riwayat-pelatihan/edit/${riwayatPelatihan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatPelatihan(riwayatPelatihan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "kepsek" || pegawai.strRole === "staff TU") &&
            pegawai.strUnit === "Pondok Pesantren" && (
              <tbody>
                {riwayatPelatihans
                  .filter(
                    (riwayatPelatihan) =>
                      riwayatPelatihan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatPelatihan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatPelatihan, index) =>
                    riwayatPelatihan.pegawai.strUnit === "Pondok Pesantren" ? (
                      <tr key={riwayatPelatihan.uuid}>
                        {index === 0}
                        <td>{index + 1}</td>
                        <td>{riwayatPelatihan.strNamaPelatihan}</td>
                        <td>{riwayatPelatihan.strPenyelenggara}</td>

                        <td>
                          {moment(riwayatPelatihan.dateTglMulai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>
                          {moment(riwayatPelatihan.dateTglSelesai).format(
                            "DD/MM/YYYY"
                          )}
                        </td>
                        <td>{riwayatPelatihan.strNoSertifikat}</td>
                        <td>
                          <a
                            href={riwayatPelatihan.url}
                            download
                            onClick={(e) => download(e)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <i className="fa fa-download" />
                            Sertifikat Pelatihan
                          </a>
                        </td>
                        <td>{riwayatPelatihan.strStatus}</td>
                        <td>{riwayatPelatihan.strKomentar}</td>
                        <td>{riwayatPelatihan.pegawai.strNama}</td>
                        <td>{riwayatPelatihan.pegawai.strUnit}</td>
                        <td>
                          <Link
                            to={`/riwayat-pelatihan/edit/${riwayatPelatihan.uuid}`}
                            className="button is-small is-info"
                          >
                            Edit
                          </Link>
                          <button
                            onClick={() =>
                              deleteRiwayatPelatihan(riwayatPelatihan.uuid)
                            }
                            className="button is-small is-danger"
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ) : null
                  )}
              </tbody>
            )}

          {pegawai &&
            (pegawai.strRole === "admin" ||
              pegawai.strRole === "kabid kepegawaian") && (
              <tbody>
                {riwayatPelatihans
                  .filter(
                    (riwayatPelatihan) =>
                      riwayatPelatihan.pegawai.strNama
                        .toLowerCase()
                        .includes(query) &&
                      riwayatPelatihan.pegawai.strUnit
                        .toLowerCase()
                        .includes(query2)
                  )
                  .map((riwayatPelatihan, index) => (
                    <tr key={riwayatPelatihan.uuid}>
                      {index === 0}
                      <td>{index + 1}</td>
                      <td>{riwayatPelatihan.strNamaPelatihan}</td>
                      <td>{riwayatPelatihan.strPenyelenggara}</td>

                      <td>
                        {moment(riwayatPelatihan.dateTglMulai).format(
                          "DD/MM/YYYY"
                        )}
                      </td>
                      <td>
                        {moment(riwayatPelatihan.dateTglSelesai).format(
                          "DD/MM/YYYY"
                        )}
                      </td>
                      <td>{riwayatPelatihan.strNoSertifikat}</td>
                      <td>
                        <a
                          href={riwayatPelatihan.url}
                          download
                          onClick={(e) => download(e)}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <i className="fa fa-download" />
                          Sertifikat Pelatihan
                        </a>
                      </td>
                      <td>{riwayatPelatihan.strStatus}</td>
                      <td>{riwayatPelatihan.strKomentar}</td>
                      <td>{riwayatPelatihan.pegawai.strNama}</td>
                      <td>{riwayatPelatihan.pegawai.strUnit}</td>
                      <td>
                        <Link
                          to={`/riwayat-pelatihan/edit/${riwayatPelatihan.uuid}`}
                          className="button is-small is-info"
                        >
                          Edit
                        </Link>
                        <button
                          onClick={() =>
                            deleteRiwayatPelatihan(riwayatPelatihan.uuid)
                          }
                          className="button is-small is-danger"
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            )}
        </table>
      </div>
    </div>
  );
};

export default RiwayatPelatihanList;
